import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CustomerFormComponent } from './customer-form/customer-form.component';
import {FormsModule} from '@angular/forms';
import {MatRippleModule} from '@angular/material/core';
import {MatDialogModule} from '@angular/material/dialog';
import { ContactFormComponent } from './contact-form/contact-form.component';
import {MatTabsModule} from '@angular/material/tabs';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {StatefulButtonModule} from "../stateful-button/stateful-button.module";



@NgModule({
  declarations: [CustomerFormComponent, ContactFormComponent],
  exports: [
    CustomerFormComponent
  ],
    imports: [
        CommonModule,
        FormsModule,
        MatRippleModule,
        MatDialogModule,
        MatTabsModule,
        MatCheckboxModule,
        StatefulButtonModule
    ]
})
export class CustomerModule { }
